module.exports = "/images/play.svg?98e4499a8eb1c5d8f9318dacde818297";